import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { StateService } from './services/state.service';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const stateService = inject(StateService)
  if (stateService.checkLogin()) {
    return true;
  } else {
    // Store attempted URL for redirect after login
    auth.redirectURL = state.url;
    return router.createUrlTree(['/login']);
  }
};
